<template>
  <div class="authController">
    <div class="formBox">
      <Login />
      <Register :class="{ active : $store.state.authController.data.currentSelection === 'Register' }" />
      <RegisterSuccess :class="{ active : $store.state.authController.data.currentSelection === 'RegisterSuccess' }"/>
    </div>
  </div>
</template>

<script>
import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'
import RegisterSuccess from '@/components/Auth/RegisterSuccess'

export default {
  name: "authController",
  components: {
    Login,
    Register,
    RegisterSuccess
  },
  data: () => ({

  }),
  created() {

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Auth/Controller";
</style>

<style lang="scss">
.footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 8;
}
</style>
